export default __webpack_public_path__ + "static/media/victory_hand.da86e69e.png";